<div class="base-spinner" *ngIf="checkShowLoading()">
  <p-progressSpinner strokeWidth="4"></p-progressSpinner>
</div>
